import React, {useState} from 'react'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {useForm} from 'react-hook-form'
import {ResourceListProps} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/ResourceList'
import {
  useAutoUpdateSidebarItem,
  useEditSidebarItem,
} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem'
import {Rule} from 'Event/attendee-rules'
import Settings from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/ResourceList/ResourceListConfig/Settings'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import RulesPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/RulesPanel'
import ScheduleInput from 'organization/Event/DashboardConfig/ComponentConfigPanel/ScheduleInput'
import Styling from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/ResourceList/ResourceListConfig/Styling'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'

export function ResourceListConfig(
  props: ComponentConfigProps & {
    list: ResourceListProps
  },
) {
  const {showing, onClose, list} = props
  const {
    handleSubmit,
    control,
    register,
    watch,
    setValue,
    formState,
  } = useForm()
  const {update, id: listId} = useEditSidebarItem()
  const [rules, setRules] = useState<Rule[]>(list.rules || [])

  const save = (data: Pick<ResourceListProps, 'title' | 'description'>) => {
    const {title, description} = data
    const localization = {
      [`sidebar_resource_list_${listId}_title`]: title || '',
      [`sidebar_resource_list_${listId}_description`]: description || '',
    }

    const updated = {
      ...data,
      title: `{{sidebar_resource_list_${listId}_title}}`,
      description: `{{sidebar_resource_list_${listId}_description}}`,
    }

    update({...updated, rules}, localization)
    onClose()
  }

  useAutoUpdateSidebarItem({item: watch(), when: showing})

  return (
    <ComponentConfig
      showing={showing}
      onClose={onClose}
      title="Resources"
      onSubmit={handleSubmit(save)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} register={register} list={list} />
      </SettingsPanel>
      <StylingPanel>
        <Styling control={control} list={list} />
      </StylingPanel>
      <RulesPanel rules={rules} setRules={setRules}>
        <ScheduleInput setValue={setValue} control={control} values={list} />
      </RulesPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
